/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_TitleInputs */

const he_auth_otp_title = /** @type {(inputs: Auth_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזינו את הקוד`)
};

const en_auth_otp_title = /** @type {(inputs: Auth_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your code`)
};

/**
* | output |
* | --- |
* | "Enter your code" |
*
* @param {Auth_Otp_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_title = /** @type {((inputs?: Auth_Otp_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_title(inputs)
	return en_auth_otp_title(inputs)
});